export const ERROR_KEY = "common.gqlError";
